export default __webpack_public_path__ + "static/media/arrow-tool.05931def.svg";